import { mutatorAction } from 'satcheljs';
import getListViewState from '../selectors/getListViewState';

export const setIsFocusWithinJumpToMutator: (value: boolean) => void = mutatorAction(
    'setIsFocusWithinJumpToMutator',
    (value: boolean): void => {
        const listViewState = getListViewState();

        listViewState.isFocusWithinJumpTo = value;
    }
);
